const C = require("../constants");

const selectSection = (data) => {
    return {
        type: C.SECTION_SELECT,
        data
    }
};

export {selectSection};


// WEBPACK FOOTER //
// ./src/actions/SectionSelectAction.js